import React from "react";
import Reveal from "@/components/Reveal";

const chapters = [
  {
    n: "I",
    title: "Formulă de parfumier",
    body: "Fiecare detergent este compus ca un parfum: note de vârf, inimă și bază. Rezultatul — o urmă olfactivă care rămâne pe țesături, discretă și rafinată.",
  },
  {
    n: "II",
    title: "Concentrat, nu diluat",
    body: "82% mai puțin plastic, dublă concentrație. O picătură face cât o cană din detergenții obișnuiți. Eficiență pură, ambalaj minim.",
  },
  {
    n: "III",
    title: "Blând cu fibrele",
    body: "Substanțele de calitate superioară din compoziție împreună cu bicarbonatul de sodiu de origine naturală dizolvă petele, nu atacă culorile și protejează mașina de spălat de apariția mirosurilor neplăcute.",
  },
];

export default function Manifesto() {
  return (
    <section id="manifest" className="py-28 md:py-40 border-t border-black/10" data-testid="manifesto-section">
      <div className="mx-auto max-w-[1600px] px-6 md:px-12">
        <Reveal className="mb-20 md:mb-28 max-w-3xl">
          <p className="text-xs tracking-[0.5em] uppercase text-gramur mb-6">Manifest</p>
          <h2 className="font-serif font-light text-4xl md:text-6xl lg:text-7xl leading-[0.95] tracking-tight">
            Nu vindem detergent. <br />
            <span className="italic text-[#4A4844]">Cultivăm un ritual.</span>
          </h2>
        </Reveal>

        <div className="space-y-16 md:space-y-24">
          {chapters.map((c, i) => (
            <Reveal key={c.n} delay={i * 0.08}>
              <div className="grid md:grid-cols-12 gap-6 md:gap-10 items-start border-t border-black/10 pt-10">
                <div className="md:col-span-3">
                  <span className="font-serif text-6xl md:text-8xl text-[#0E0F12]/15">{c.n}</span>
                </div>
                <h3 className="md:col-span-4 font-serif text-3xl md:text-4xl leading-tight">
                  {c.title}
                </h3>
                <p className="md:col-span-5 text-[#4A4844] text-base leading-relaxed md:pl-8">
                  {c.body}
                </p>
              </div>
            </Reveal>
          ))}
        </div>
      </div>
    </section>
  );
}
